export const ru = {
    'banners-add-archived-group':
        'В архивные группы нельзя добавить объявления.',
    'banners-in-group-limit':
        'В группу может быть добавлено не более 50 объявлений.'
};
